import { useContext } from 'react';
import { EmployeeContext } from './Employee.context';

export const useEmployee = () => {
	const context = useContext(EmployeeContext);

	if (!context) {
		throw new Error('useEmployee must be used within a EmployeeProvider');
	}

	return context;
};
